import { Image } from "@nextui-org/react";
import React from "react";
import { Link } from "react-router-dom";
import { CardBody, CardContainer, CardItem } from "../ui/3d-card";

const ArticleCard = ({ article, page }) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return (
    <CardContainer className={`shadow-mainShadow flex flex-col min-w-fit h-full ${page === "blogs"
      ? "w-full"
      : "xl:w-[calc(50%-20px)] lg:w-[calc(50%-80px)] md:w-[calc(50%-20px)] min-[540px]:w-[75%]"
      }`}>
      <CardBody className="flex flex-col justify-center  h-full">
        <CardItem className="relative">
          <Image
            classNames={{ wrapper: "size-full rounded-none min-h-[281px]" }}
            className="rounded-none size-full"
            src={article?.image}
            alt={article?.title}
          />
        </CardItem>
        <CardItem className="px-4 flex flex-col flex-grow">
          <div className="flex-grow mb-5">
            <h3 className="text-secondaryBlack sm:text-[24px] text-lg leading-[24.82px] mt-3 line-clamp-3">
              <Link to={`/travel-blogs/blog/${article?.slug}`}>
                {article?.title}
              </Link>
            </h3>
            <div className="flex items-center gap-2 mt-4">
              <div className="flex items-center gap-1">
                <div className="w-4 h-4 rounded-full bg-[#D9D9D9]" />
                <p className="text-secondaryBlack leading-[40px] sm:text-base text-sm">
                  {article?.author}
                </p>
              </div>
              {article?.author && (
                <div className="min-[390px]:w-9 w-4 h-px bg-secondaryGray opacity-40" />
              )}
              <p className="text-sm text-secondaryGray">{months[+article?.published_at?.split("-")[1] - 1]} {article?.published_at?.split(" ")[0].split("-")[2] > 9 ? article?.published_at?.split(" ")[0].split("-")[2] : article?.published_at?.split(" ")[0].split("-")[2]?.slice(1)}, {article?.published_at?.split("-")[0]}</p>
            </div>
          </div>
          <Link
            to={`/travel-blogs/blog/${article?.slug}`}
            className="text-secondaryBlack underline underline-offset-[12px] block mb-8 leading-[20.96px]"
          >
            View Post
          </Link>
        </CardItem>
      </CardBody>
    </CardContainer>
  );
};

export default ArticleCard;

// import { Image } from "@nextui-org/react";
// import React from "react";
// import { Link } from "react-router-dom";
// import { CardBody, CardContainer, CardItem } from "../ui/3d-card";

// const ArticleCard = ({ article, page }) => {
//   return (
//     <CardContainer className={`shadow-mainShadow flex flex-col min-w-fit h-full ${
//       page === "blogs"
//         ? "w-full"
//         : "xl:w-[calc(50%-20px)] lg:w-[calc(50%-80px)] md:w-[calc(50%-20px)] min-[540px]:w-[75%]"
//     }`}>
//       <CardBody className="flex flex-col justify-center  h-full">
//         <CardItem className="relative">
//           <Image
//             classNames={{ wrapper: "size-full rounded-none min-h-[281px]" }}
//             className="rounded-none size-full"
//             src={article.background}
//             alt={article.title}
//           />
//         </CardItem>
//         <CardItem className="px-4 flex flex-col flex-grow">
//           <div className="flex-grow mb-[62px]">
//             <h3 className="text-secondaryBlack sm:text-[24px] text-lg leading-[24.82px] mt-3 line-clamp-3">
//               <Link to={`/travel-blogs/blog/${article.title}`}>
//                 {article.smTitle}
//               </Link>
//             </h3>
//             <div className="flex items-center gap-2 mt-4">
//               <div className="flex items-center gap-1">
//                 <div className="w-4 h-4 rounded-full bg-[#D9D9D9]" />
//                 <p className="text-secondaryBlack leading-[40px] sm:text-base text-sm">
//                   {article.author}
//                 </p>
//               </div>
//               <div className="min-[390px]:w-9 w-4 h-px bg-secondaryGray opacity-40" />
//               <p className="text-sm text-secondaryGray">{article.date}</p>
//             </div>
//           </div>
//           <Link
//             to={`/travel-blogs/blog/${article.title}`}
//             className="text-secondaryBlack underline underline-offset-[12px] block mb-8 leading-[20.96px]"
//           >
//             View Post
//           </Link>
//         </CardItem>
//       </CardBody>
//     </CardContainer>
//   );
// };

// export default ArticleCard;